


































































































import { Component, Vue, Prop } from "vue-property-decorator";
import moment from "moment";

@Component
export default class DatePicker extends Vue {
  public modalStartDate = false;
  public modalEndDate = false;
  @Prop(String) public startDate!: string;
  @Prop(String) public endDate!: string;

  public localStartDate = this.startDate;
  public localEndDate = this.endDate;

  get formatStartDate() {
    return this.formatDate(this.startDate);
  }

  get formatEndDate() {
    return this.formatDate(this.endDate);
  }

  get maxStartDate() {
    return this.endDate;
  }

  get maxEndDate() {
    return moment().format("YYYY-MM-DD");
  }

  get minStartDate() {
    return moment(this.localEndDate)
      .subtract("months", 13)
      .format("YYYY-MM-DD");
  }

  get minEndDate() {
    return this.startDate;
  }

  public updateStartDate(date: string) {
    this.$emit("updateStartDate", date);
    this.modalStartDate = false;
  }

  public updateEndDate(date: string) {
    this.$emit("updateEndDate", date);
    this.modalEndDate = false;
  }

  public onSubmit() {
    this.$emit("submit");
  }

  public formatDate(date: string) {
    return moment(date).format("MMM DD, YYYY");
  }
}
